/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'app': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M417.798 1016.253c28.67 16.895 51.197 5.632 51.197-28.67V588.761c0-34.302-23.039-68.603-51.197-85.498L87.58 297.964c-28.67-11.263-51.197 0-51.197 28.67v398.822c0 34.302 23.039 68.604 51.197 85.499l330.218 205.298zm-279.021-843.72c-28.67 16.895-28.67 39.933 0 56.828l325.098 205.298c28.67 16.895 68.604 16.895 96.762 5.632l325.098-165.365c28.67-16.895 28.67-39.933 0-56.828L543.23 12.799c-23.039-16.895-68.604-16.895-96.762 0L138.777 172.533zm421.86 815.05c0 34.302 23.038 45.565 51.196 28.67l325.099-165.365c28.67-16.895 51.197-51.197 51.197-85.498V366.056c0-34.302-23.039-45.565-51.197-28.67L611.833 502.75c-28.67 16.895-51.196 51.197-51.196 85.498v399.334z"/>'
  }
})
